import { render, staticRenderFns } from "./PaintDetail.vue?vue&type=template&id=e56f78fa&scoped=true&"
import script from "./PaintDetail.vue?vue&type=script&lang=js&"
export * from "./PaintDetail.vue?vue&type=script&lang=js&"
import style0 from "./PaintDetail.vue?vue&type=style&index=0&id=e56f78fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56f78fa",
  null
  
)

export default component.exports